import { usePlatformChecklistTrackers } from "../use-platform-checklist-trackers";
import { OnboardingProgressCard } from "./onboarding-progress-card";

export const PlatformOnboardingSidebar = () => {
  usePlatformChecklistTrackers();
  return <OnboardingProgressCard />;
};
